import * as React from 'react';

interface IClientComponentProps {
  children: React.ReactElement;
  fallback?: React.ReactElement;
}

export const ClientComponent: React.FC<IClientComponentProps> = ({ fallback, children }) => {
  const [isBrowser, setIsBrowser] = React.useState(false);
  const isBrowserBuild = process.env.IS_BROWSER_BUILD;

  React.useEffect(() => {
    setIsBrowser(Boolean(isBrowserBuild));
  }, [isBrowserBuild]);

  return isBrowser ? children : fallback || null;
};
